import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalCancelTravelComponent } from './modal-cancel-travel.component';
import { CustomInputModule } from '../custom-input/custom-input.module'; 

@NgModule({
  declarations: [
    ModalCancelTravelComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,   
    CustomInputModule      
  ],
  exports: [
    ModalCancelTravelComponent
  ]
})
export class ModalCancelTravelModule { }
